import { useState } from 'react';
import { IoIosCloseCircleOutline } from 'react-icons/io';
import { IoSearch } from 'react-icons/io5';
import styled, { useTheme } from 'styled-components';

export type SearchBarPropsType = {
  width?: string;
  margin?: string;
  onSearch: (searchTerm: string) => void;
  onClear?: () => void;
};

export const SearchBar = ({
  width = '100%',
  margin = '0px',
  onSearch,
  onClear,
}: SearchBarPropsType) => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const theme = useTheme();
  return (
    <Container $width={width} $margin={margin}>
      <div className='label-icon'>
        {searchTerm.trim() === '' ? (
          <IoSearch color={theme.colors.charcoal} size={24} />
        ) : (
          <IoIosCloseCircleOutline
            color={theme.colors.charcoal}
            size={25}
            strokeWidth={5}
            onClick={() => {
              if (onClear === undefined) {
                setSearchTerm('');
                onSearch('');
              } else {
                onClear();
              }
            }}
            style={{ cursor: 'pointer' }}
          />
        )}
      </div>
      <SearchInput
        className='input-section'
        type='text'
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            // e.currentTarget.blur();
            onSearch(searchTerm);
          }
        }}
      />
      <h4 className='button-section' onClick={() => onSearch(searchTerm)}>
        검색
      </h4>
    </Container>
  );
};

const Container = styled.div<{
  $width?: string;
  $margin?: string;
}>`
  width: ${({ $width }) => $width};
  background-color: white;
  height: 30px;
  border: 2px solid ${({ theme }) => theme.colors.charcoal};
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: ${({ $margin }) => $margin};

  .label-icon {
    flex: 0 0 12%;
    text-align: center;
    padding-top: 3px;
  }
  .input-section {
    flex: 1 0 40%;
    height: 80%;
  }
  .button-section {
    flex: 0 0 22%;
    text-align: center;
    align-content: center;
    height: 100%;
    margin: 0;
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`;

const SearchInput = styled.input`
  border: none;
  padding: 0px 10px;
  background-color: transparent;
  border-bottom: 1px solid black;
`;
